import React from "react";
import { ArrowRight } from "lucide-react";

const handleScroll = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};

export const Hero = () => {
  return (
    <section
      id="beranda"
      data-testid="hero-section"
      className="relative pt-36 pb-24 lg:pt-48 lg:pb-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left: text */}
          <div className="lg:col-span-7 hp-rise">
            <div className="flex items-center gap-3 mb-7">
              <span className="hp-divider" />
              <span className="overline">Notaris &amp; PPAT — Helen Parlista, S.H, M.Kn</span>
            </div>

            <h1
              data-testid="hero-headline"
              className="font-serif text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[0.95] tracking-tight text-[#1A2B29] font-light"
            >
              Kepastian hukum,
              <br />
              <em className="font-serif italic text-[#C4A661]">pendekatan yang personal.</em>
            </h1>

            <p className="mt-9 max-w-xl text-base lg:text-lg text-[#5C6B69] leading-relaxed">
              Layanan kenotariatan profesional untuk individu, keluarga, dan badan usaha — dari
              pendirian PT, akta jual beli tanah, perjanjian pranikah, hingga akta wasiat. Diurus
              dengan teliti, dijelaskan dengan jelas.
            </p>

            <div className="mt-11 flex flex-wrap gap-4">
              <button
                type="button"
                onClick={() => handleScroll("kontak")}
                data-testid="hero-cta-primary"
                className="btn-primary"
              >
                Lihat Kontak <ArrowRight size={16} />
              </button>
              <button
                data-testid="hero-cta-secondary"
                onClick={() => handleScroll("layanan")}
                className="btn-outline"
              >
                Lihat Layanan
              </button>
            </div>

            <div className="mt-14 grid grid-cols-3 gap-6 max-w-lg">
              {[
                { k: "S.H, M.Kn", v: "Bersertifikat" },
                { k: "Jabar", v: "Wilayah Tugas" },
                { k: "100%", v: "Kerahasiaan Klien" },
              ].map((s, i) => (
                <div key={i} className="hp-rise hp-rise-delay-2">
                  <div className="font-serif text-3xl lg:text-4xl text-[#1A2B29]">{s.k}</div>
                  <div className="mt-1 text-xs uppercase tracking-[0.18em] text-[#5C6B69]">
                    {s.v}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: editorial portrait composition */}
          <div className="lg:col-span-5 relative hp-rise hp-rise-delay-2">
            <div className="relative aspect-[3/4] overflow-hidden">
              <img
                src="/assets/helen-portrait.png"
                alt="Helen Parlista, S.H, M.Kn — Notaris & PPAT"
                className="w-full h-full object-cover object-center"
                data-testid="hero-portrait"
              />
              <div className="absolute inset-0 ring-1 ring-[#1A2B29]/10" />
            </div>

            {/* Caption card overlap */}
            <div className="absolute -left-6 lg:-left-12 bottom-8 bg-[#F9F8F6] border border-[#E5E3DC] py-5 px-6 max-w-[260px] hidden md:block">
              <div className="overline mb-2">Tertanda</div>
              <div className="font-serif text-2xl text-[#1A2B29] leading-tight">
                Helen Parlista,
                <br />
                <span className="italic">S.H, M.Kn</span>
              </div>
              <div className="mt-3 text-xs text-[#5C6B69]">
                SK Kemenkumham — Notaris &amp; PPAT
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
